// main component imports
import { LoadingAnimation, Error } from "Component";

// redux store imports
import { useGetIconQuery } from "api/other/other";

const IconCard = ({ value, onClick, search }) => {
  // fetch icon from api using rtk query
  const { data, isLoading, isError, error, isSuccess } = useGetIconQuery()

  // filter list according to search
  const filteredList = isSuccess && data?.filter(item => item.name?.toLowerCase().includes(search))

  // isLoading, isError and no data found component
  if (isLoading) return <LoadingAnimation />
  if (isError) return <Error error={error} />
  if (filteredList?.length<=0) return <p className="
  mues_font_weight_500 mues_grey_II">No Data Found</p>
  return (
    filteredList?.map(icon => (
      <div className={`icon_card mues_pointer 
        ${value === icon.icon && 'active_icon_card'}`}
        key={icon.id} onClick={() => onClick(icon.icon)}>
        <img src={icon.icon} alt={icon.name} />
      </div>
    ))
  )
}

export default IconCard